import React from "react";
// Store Utils
import { useDispatch } from "react-redux";
import { observationsStatusAction } from "store/filters/reducer.actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { sentenceCase } from "change-case";
import { filtersInitialState } from "store/filters/initialState";

interface TabsProps {}

export const Tabs: React.FC<TabsProps> = ({}) => {
  const { observationsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const dispatch = useDispatch();
  const tabsData = [
    {
      title: "All",
      value: "all",
    },
    {
      title: "In Review",
      value: "in_review",
    },
    {
      title: "Complete",
      value: "completed",
    },
    {
      title: "Incomplete",
      value: "incompleted",
    },
    {
      title: "Archived",
      value: "archived",
    },
    
  ];
  //handlers
  const handleLink = (linkName: string) => {
    dispatch(observationsStatusAction(linkName));
  };

  return (
    <>
      {tabsData.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`group flex cursor-pointer justify-center items-center flex-grow-0 flex-shrink-0 px-4 py-3 ${
              observationsFilter.status === item.value
                ? "border-b-2 border-primaryMid "
                : "border-lineMid border-b-2  hover:border-lineDarkExtra"
            }`}
            onClick={() => handleLink(item.value)}
          >
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1.5 pt-1.5 pb-2 ">
              <p
                className={`flex-grow-0 flex-shrink-0 text-sm font-semibold text-center uppercase text-secondary group-hover:dark:text-textMain ${
                  observationsFilter.status === item.value
                    ? " dark:text-textMain "
                    : "dark:text-caption "
                }`}
              >
                {sentenceCase(item.title)}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};
